var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"17","viewBox":"0 0 30 17"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","d":"M15 0l15 17H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }